export const environment = {
  production: true,
  basePath: 'https://stagingapi.clincor.com.au/',
  idleTimeEnable: true,
  magneticHolder: 'Web@Clincor~2025',
  sysMagneticHolder: 'Web@Clincor~2025',
  spaceKey: 'DnqAuZE7P5BVZd95ShgXQj0aW9HDnIKsV1sZSrFucTk=',
  tenantCode: 'taks',
  supportedCountry: ['AU'],
  version: '1.0.4'
};
